<template>
  <div class="vertical-card --bordered --blue-border" data-faux-anchor="true">
    <div class="vertical-card__body --bg-white --padded">
      <div>
        <h2 class="vertical-card__header --large">
          <a :href="link">{{ title }}</a>
        </h2>
      </div>
      <p class="vertical-card__body-copy">
        {{ copy }}
      </p>
      <div class="vertical-card__secondary-container --flex-end">
        <svg
          class="vertical-card__secondary-icon --blue"
          width="30px"
          height="13px"
          viewBox="0 0 30 13"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <path
            d="M28,6.33492073 L28.1913673,6.14505595 L28.1913673,6.85494405 L28,6.66507927 L28,6.33492073 Z M27.3296576,7 L22.6478428,11.6450559 L23.3521572,12.3549441 L28.8956818,6.85494405 L29.2534347,6.5 L28.8956818,6.14505595 L23.3521572,0.645055948 L22.6478428,1.35494405 L27.3296576,6 L0,6 L0,7 L27.3296576,7 Z"
            id="Combined-Shape"
          ></path>
        </svg>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['copy', 'title', 'link']
}
</script>
